import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cancelTokenArr: []
  },
  mutations: {
    pushToken: function (state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
    },
    clearToken: function (state) {
      state.cancelTokenArr.forEach((item) => {
        item('路由跳转取消请求')
      })
      state.cancelTokenArr = []
    }
  },
  actions: {},
  modules: {}
})
